module.exports = __webpack_public_path__ + "static/media/Search-Error.b8d7f6a5.svg";